import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import PageHead from "../../../Components/PageHead/PageHead";
import DataTable from "../../../Components/DataTable/DataTable";
import Url from "../../../Services/Url";
import { Get } from "../../../Services/Server";
import { getRoleNames } from "./Roles";
import "./Announcement.css";
import Time from "../../../Services/Time";
import Utils from "../../../Services/Utills";


const AnnouncementList = ({ navoption }) => {
	const Navigate = useNavigate();
	const [announcementList, setAnnouncementList] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchAnnouncements = () => {
			setLoading(true);
			Get(Url.notification.getAll)
				.then((data) => {
					const formattedData = data.map((item) => {
						let parsedRoleIds = [];
						try {
							if (item.roleIds) {
								const cleanedRoleIds = item.roleIds.replace(/'/g, '"');
								parsedRoleIds = JSON.parse(cleanedRoleIds);
							}
						} catch (e) {
							console.warn("Failed to parse roleIds for item:", item.id, e);
							parsedRoleIds = [];
						}

						return {
							...item,
							roleIds: parsedRoleIds,
						};
					});

					setAnnouncementList(formattedData);
				})
				.catch((error) => {
					console.error("Error fetching announcements:", error);
				})
				.finally(() => {
					setLoading(false);
				});
		};

		fetchAnnouncements();
	}, []);

	const onAnnouncementClick = (item) => {
		Navigate(`${item.id}`, { state: item });
	};

	const renderUserConfig = (roleIds) => {
		const roleNames = getRoleNames(roleIds);
		const isAllUsers = roleNames.includes("All Users");

		if (isAllUsers) {
			return <span className="user-config all-users">All Roles</span>;
		}

		return (
			<div className="user-config-container">
				{roleNames.slice(0, 4).map((name, index) => (
					<span key={index} className={`user-badge role`}>
						{name}
					</span>
				))}
				{roleNames.length > 4 && (
					<span className="user-badge overflow">+{roleNames.length - 4}</span>
				)}
			</div>
		);
	};

	const UserRec = (item) => [
		<div key={0} className="content-col">
			<div className="content-preview">
				{item.title && item.title.length > 50
					?  Utils.toPascalCase(`${item.title.substring(0, 50)}...`)
					: Utils.toPascalCase(item.title) || "No Title"}
			</div>
		</div>,

		<div key={1} className="start-date-col">
			{item.startDate ? Time.getDate(item.startDate) : "N/A"}
		</div>,

		<div key={2} className="end-date-col">
			{item.endDate ? Time.getDate(item.endDate) : "N/A"}
		</div>,

		<div key={3} className="user-config-col">
			{renderUserConfig(item.roleIds)}
		</div>,

		<span key={4}>
			{item.updatedAt ? Time.getDateTime(item.updated_at) : "N/A"}
		</span>,
	];

	const heading = [
		"Title",
		"Start Date",
		"End Date",
		"User Configuration",
		"Updated At",
	];
	const flex = [30, 15, 15, 25, 15];

	const handleNewAnnouncement = () => {
		Navigate("create");
	};

	return (
		<div className="Announcement">
			<PageHead
				newBtn={{ text: "Announcement", onClick: handleNewAnnouncement }}
				navoption={navoption}
			/>
			<div className="AnnouncementList" id="ModalRoot">
				{loading ? (
					<div className="loading-container">
						<span>Loading...</span>
					</div>
				) : (
					<DataTable flex={flex} onClick={onAnnouncementClick} reader={UserRec}>
						{{
							heading,
							data: announcementList,
						}}
					</DataTable>
				)}
			</div>
		</div>
	);
};

export default AnnouncementList;